import { LoyaltyProgramTier as GqlLoyaltyTier } from '../gql-operations/gql-generated';

// FE generated type
export { GqlLoyaltyTier };

// Please don't use this enum on the frontend,
// as it is used to defined the schema of tiers in pegasus
export enum LoyaltyProgramTier {
    SILVER = 'SILVER',
    GOLD = 'GOLD',
    PLATINUM = 'PLATINUM',
    DIAMOND = 'DIAMOND',
}
